---
id: go-shared-entities
title: Shared entities
owner: Backend Team
status: Active
lastReviewed: 2026-01-30
visibility: internal
tags:
  - entities
  - shared
  - payment
---

## Product Overview

### Who it serves

This shared package defines core entity types and constants reused across Go services for user and payment data.

### Primary workflow

Service code imports entity types to model user details and payment plan metadata, keeping cross-service contracts aligned.

### Business rules

Payment products map to plan types and analyzer plans, and helper methods enforce consistent plan classification across services.

### Outcomes

Services share a single source of truth for user entity shapes and payment plan identifiers.

### Out of scope

Service-specific business logic and billing workflows are implemented in the consuming services.

## Technical Overview

### Architecture flow

The package provides struct definitions and enums for user data and payment plan classification that are referenced by callers and services.

### Entry points

Key entry points include `UserDetails` in `apps/micro-services/go-shared/entities/user/user.go` and the payment types in `apps/micro-services/go-shared/entities/payment/plan.go`.

### Key modules

`user/user.go` defines the user profile payload, while `payment/plan.go` defines plan IDs, plan types, and analyzer plan helpers, with enterprise billing constants in `payment/enterprise.go`.

### Data sources and sinks

These entities are populated from database records or external billing systems and are consumed by API handlers and service logic.

### Integrations and side effects

The package references Stripe product and price IDs to classify plan tiers, but has no runtime side effects.

### Constraints and risks

If product IDs or plan mappings change, all dependent services must be updated to keep billing and access logic consistent.

## Changelog

- 2026-01-30: Initial documentation.
